import {detailServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + "/organizations/compositions/paced-modules";

/**
 * Размещение модуля (`PacedModuleDto`).
 * GET `/{id}` — id записи paced-module.
 * GET `/by-module-id?moduleId=` — размещение по id модуля (`PacedModuleDto`, incl. `hide`).
 * POST `?moduleId=` — создать размещение (точка с бэка).
 * PUT `/{id}` — сохранение позы (`PacedModuleDto` в body).
 * PATCH `/{id}/hide` — скрыть/показать (`boolean` в body).
 * PATCH `/show-or-hide-all-depend?moduleId=` — все зависимые модули (`boolean` в body).
 * PATCH `/{id}/hide-all-except?moduleId=` — скрыть все, кроме `{id}`.
 * DELETE `/{id}` — снять размещение.
 */
export default class PacedModulesService {
    static async getById(pacedModuleId) {
        return axios.get(`${restUrl}/${pacedModuleId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    static async getByModuleId(moduleId) {
        return axios.get(`${restUrl}/by-module-id`, {
            params: {moduleId},
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    static async save(moduleId, data) {
        return axios.post(
            `${restUrl}?moduleId=${moduleId}`,
            JSON.stringify(data ?? {}),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }

    static async update(pacedModuleId, data) {
        return axios.put(`${restUrl}/${pacedModuleId}`, JSON.stringify(data), {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /** PATCH `/{id}/hide` — body: `true` скрыть, `false` показать. */
    static async setHide(pacedModuleId, hide) {
        return axios.patch(`${restUrl}/${pacedModuleId}/hide`, JSON.stringify(Boolean(hide)), {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    static async delete(pacedModuleId) {
        return axios.delete(`${restUrl}/${pacedModuleId}`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /** PATCH `/show-or-hide-all-depend?moduleId=` — body: `true` скрыть все, `false` показать все. */
    static async showOrHideAllDepend(moduleId, hide) {
        return axios.patch(`${restUrl}/show-or-hide-all-depend`, JSON.stringify(Boolean(hide)), {
            params: {moduleId},
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    /**
     * PATCH `/{id}/hide-all-except?moduleId=` — body: `true` скрыть все, кроме `{id}`.
     */
    static async hideAllExcept(pacedModuleId, moduleId, hide = true) {
        return axios.patch(
            `${restUrl}/${pacedModuleId}/hide-all-except`,
            JSON.stringify(Boolean(hide)),
            {
                params: {moduleId},
                headers: {
                    "Content-Type": "application/json",
                },
            },
        );
    }
}
